<template>
  <transition name="benefit-modal">
    <div
      class="benefit-modal-backdrop"
      role="presentation"
      @click.self="$emit('close')"
    >
      <section
        class="benefit-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="benefit-modal-title"
        aria-describedby="benefit-modal-description"
      >
        <button
          type="button"
          class="benefit-modal-close material-icons"
          aria-label="Fechar aviso"
          @click="$emit('close')"
        >
          close
        </button>

        <div class="benefit-modal-icon" aria-hidden="true">
          <span class="material-icons">volunteer_activism</span>
        </div>

        <span class="benefit-modal-kicker">Benefício exclusivo CDL/BH</span>
        <h2 id="benefit-modal-title">
          Você tem um novo benefício CDL/BH para ativar!
        </h2>

        <div id="benefit-modal-description" class="benefit-modal-content">
          <p>
            Por ser associado à CDL/BH, você pode ativar gratuitamente a
            <strong>Assistência Funeral CDL.</strong> Para empresas, são até 2
            sócios elegíveis; para pessoa física, o próprio titular.
          </p>
          <p>
            Mais proteção, cuidado e tranquilidade para você e sua família.
          </p>
          <p class="benefit-modal-alert">
            Não deixe esse benefício disponível sem ativar.
          </p>
        </div>

        <button
          ref="activateButton"
          type="button"
          class="benefit-modal-action"
          @click="$emit('activate')"
        >
          <span>Ativar benefício</span>
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </button>

        <button
          type="button"
          class="benefit-modal-later"
          @click="$emit('close')"
        >
          Agora não
        </button>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  name: "BeneficioFuneralModal",
  data() {
    return {
      bodyOverflowAnterior: "",
    };
  },
  mounted() {
    this.bodyOverflowAnterior = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", this.fecharComEscape);
    this.$nextTick(() => this.$refs.activateButton.focus());
  },
  beforeDestroy() {
    document.body.style.overflow = this.bodyOverflowAnterior;
    window.removeEventListener("keydown", this.fecharComEscape);
  },
  methods: {
    fecharComEscape(event) {
      if (event.key === "Escape") this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.benefit-modal-backdrop {
  align-items: center;
  background: rgba(0, 39, 91, 0.78);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 1.25rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2000;
}

.benefit-modal-card {
  background: linear-gradient(150deg, #ffffff 68%, #edf9f1 100%);
  border-radius: 18px;
  box-shadow: 0 24px 70px rgba(0, 21, 54, 0.35);
  max-width: 620px;
  overflow: hidden;
  padding: 2.4rem 3rem 2rem;
  position: relative;
  text-align: center;
  width: 100%;

  &::before {
    background: linear-gradient(90deg, #00a04e, #8cc63f);
    content: "";
    height: 8px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
}

.benefit-modal-close {
  background: transparent;
  border: 0;
  color: #5d6878;
  cursor: pointer;
  font-size: 1.5rem;
  padding: 0.4rem;
  position: absolute;
  right: 0.8rem;
  top: 0.8rem;

  &:hover,
  &:focus {
    color: #05428e;
  }
}

.benefit-modal-icon {
  align-items: center;
  background: #e7f7ed;
  border-radius: 50%;
  display: flex;
  height: 78px;
  justify-content: center;
  margin: 0 auto 1rem;
  width: 78px;

  .material-icons {
    color: #00a04e;
    font-size: 2.8rem;
  }
}

.benefit-modal-kicker {
  color: #00a04e;
  display: block;
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  margin-bottom: 0.55rem;
  text-transform: uppercase;
}

h2 {
  color: #05428e;
  font-size: 1.75rem;
  font-weight: 800;
  line-height: 1.2;
  margin: 0 auto 1rem;
  max-width: 500px;
}

.benefit-modal-content {
  color: #303b4c;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0 auto;
  max-width: 510px;

  p {
    margin-bottom: 0.75rem;
  }
}

.benefit-modal-alert {
  color: #05428e;
  font-weight: 700;
}

.benefit-modal-action {
  align-items: center;
  background: #00a04e;
  border: 0;
  border-radius: 8px;
  box-shadow: 0 8px 18px rgba(0, 120, 68, 0.24);
  color: #ffffff;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.95rem;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0.025em;
  margin-top: 0.5rem;
  padding: 0.9rem 1.5rem;
  text-transform: uppercase;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  .material-icons {
    font-size: 1.25rem;
    margin-left: 0.5rem;
  }

  &:hover,
  &:focus {
    background: #008d45;
    box-shadow: 0 10px 22px rgba(0, 120, 68, 0.32);
    color: #ffffff;
    transform: translateY(-2px);
  }
}

.benefit-modal-later {
  background: transparent;
  border: 0;
  color: #667085;
  cursor: pointer;
  display: block;
  font-size: 0.8rem;
  margin: 0.85rem auto 0;
  padding: 0.3rem 0.75rem;
  text-decoration: underline;
}

.benefit-modal-enter-active,
.benefit-modal-leave-active {
  transition: opacity 0.22s ease;
}

.benefit-modal-enter-active .benefit-modal-card,
.benefit-modal-leave-active .benefit-modal-card {
  transition: transform 0.22s ease;
}

.benefit-modal-enter,
.benefit-modal-leave-to {
  opacity: 0;
}

.benefit-modal-enter .benefit-modal-card,
.benefit-modal-leave-to .benefit-modal-card {
  transform: translateY(16px) scale(0.98);
}

@media screen and (max-width: 576px) {
  .benefit-modal-card {
    max-height: calc(100vh - 2rem);
    overflow-y: auto;
    padding: 2rem 1.3rem 1.4rem;
  }

  .benefit-modal-icon {
    height: 64px;
    width: 64px;

    .material-icons {
      font-size: 2.25rem;
    }
  }

  h2 {
    font-size: 1.4rem;
  }

  .benefit-modal-content {
    font-size: 0.92rem;
  }

  .benefit-modal-action {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .benefit-modal-enter-active,
  .benefit-modal-leave-active,
  .benefit-modal-enter-active .benefit-modal-card,
  .benefit-modal-leave-active .benefit-modal-card,
  .benefit-modal-action {
    transition: none;
  }
}
</style>
